import { useParams } from 'react-router-dom';

export const useTelegramUser = () => {
  const { userId } = useParams<{ userId: string }>();

  return (
    Telegram.WebApp.initDataUnsafe.user ||
    ({ id: userId, is_bot: false } as unknown as WebAppUser)
  );
};
